module.exports = __webpack_public_path__ + "static/media/chicken.7c216030.png";